import React, { useState } from "react";
import ConfigDB from "../../Config/Theme-Config";
import Context from "./index";

const AnimationThemeProvider = (props) => {
  const [animation, setAnimation] = useState(ConfigDB.data.router_animation || "");

  const routerAnimation = (layout_anim) => {
    ConfigDB.data.settings.router_animation = layout_anim;
    localStorage.setItem("animation", layout_anim);
    setAnimation(layout_anim);
  };

  return (
    <Context.Provider value={{ animation, routerAnimation }}>
      {props.children}
    </Context.Provider>
  );
};

export default AnimationThemeProvider;
